module.exports = __webpack_public_path__ + "static/playstore-50bb64d5f5ade1868cd790b47b4f9f74.svg";